import Title from "antd/es/typography/Title";
import { IntegrationErrorBarChart } from "components/Charts/IntegrationErrorBarChart/IntegrationErrorBarChart.tsx";
import { generateMockData } from "components/Charts/IntegrationErrorBarChart/types.ts";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";


export const ErrorsChartSection: FC = () => {
    const { t } = usePaldockTranslation("forms.connection-creator-errors-chart");

    return (
        <div className={"h-[500px] p-6 mb-6"}>
            <Title level={3} className="!mb-6 !-mt-4">
                {t("sections.integration_errors.title")}
            </Title>
            <IntegrationErrorBarChart
                data={generateMockData()}
                xAxisDataKey={"date"}
                displayLegend={false}
                displayTooltip={true}
            />
        </div>
    );
};
